import Institucion from '@/api/institucion'
import _ from 'lodash'
import Vue from 'vue'

const state = {
  institucion: null,
  cargando: false,
  guardando: false,
  editando: false
}

const getters = {
  cargando: state => {
    return state.cargando
  },
  institucion: state => {
    return state.institucion
  },
  editando: state => {
    return state.editando
  }
}

const actions = {
  obtener (context, payload) {
    const { id } = payload

    return new Promise((resolve, reject) => {
      Institucion.obtener(id).then(
        data => {
          context.commit('setearInstitucion', data)
          resolve(data)
        },
        error => {
          context.commit('mostrarError', error)
          reject(error)
        }
      )
    })
  },

  actualizarSeccion (context, payload) {
    const datos = payload
    datos.id = context.getters.institucion.id
    context.commit('cargando', true)
    return new Promise((resolve, reject) => {
      Institucion.guardar(datos).then(
        data => {
          Vue.notify({
            group: 'general',
            type: 'success',
            text: 'Los datos se guardaron correctamente!'
          })
          context.commit('actualizar', data)
          resolve(data)
        },
        error => {
          context.commit('cargando', false)
          // context.commit('loginUserFailure', error)
          reject(error)
          // }, 500)
        }
      )
    })
  },
  editar (context, payload) {
    context.commit('editar', payload)
  }
}

const mutations = {
  cargando (state, payload) {
    state.cargando = payload
  },

  setearInstitucion (state, institucion) {
    state.institucion = institucion
  },
  actualizar (state, datos) {
    state.cargando = false
    state.institucion = _.assign(state.institucion, datos)
  },
  editar (state, valor) {
    state.editando = valor
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
